import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const marseilleCustomerGroup = 'marseille_food_market';
export const customerGroup = marseilleCustomerGroup;

const supportEmail = {
	marseille_food_market: 'marseille@smoothr.de'
};
const firebaseConfig = {
	marseille_food_market: {
		apiKey: 'AIzaSyBplxv1KpMXUSgrF7XGTqC7ktgvnqyk-dI',
		authDomain: 'marseille-ab433.firebaseapp.com',
		projectId: 'marseille-ab433',
		storageBucket: 'marseille-ab433.appspot.com',
		messagingSenderId: '356800196644',
		appId: '1:356800196644:web:8713e4848c1137dc5a28b1'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyB1zuV-fVlLlytAWtsVdSapFLRkuETwcyg',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de']
};
